import React from 'react';
window.React = React;
